import React from 'react';
import img from './img_1.png';

const About = () => {
    return (
        <div className='about'>
            <div className='about__container'>
                <div className='about__image'>
                <div className='about__image_dots'>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>
                <div className="about__image_dots_dot"></div>

                </div>
                
                <div className='about__image_semi-circle'></div>
                <div className='about__image_circle-yellow'></div>                
                <img className='about__image_image'></img>
                </div>
                <div className='about__text'>
                <div className='about__text_circle-lines'>
                <div className='about__text_circle-lines_line'></div>
                <div className='about__text_circle-lines_line'></div>
                <div className='about__text_circle-lines_line'></div>
                <div className='about__text_circle-lines_line'></div>
                <div className='about__text_circle-lines_line'></div>
                <div className='about__text_circle-lines_line'></div>
 
            </div>
                    <div className='about__text_country'>About</div>
                    <h3 className='about__text_header'>Our Goals</h3>
                    <div className='about__text_description'>We believe work is about people and ideas. qSpace are inhabited by forward thinkers, innovators and game changers who are confident in achieving their goals. </div>
                    <div className='about__text_button'>Learn More →</div>


                </div>
            </div>
            
        </div>
    );
};

export default About;